import React from 'react';
import { Button, Flex } from '@gjensidige/builders-components';
import { AbortPurchase } from '@gjensidige/se-abort-popup';
import { useAppSelector } from '../../../hooks/appHooks';
import { RoutingHelper } from '../../../utils/RoutingHelper';
import tracker from '../../../tracking';
import { useDeviceWidth } from '../../../hooks/useDeviceWidth';

interface IFooterButtonProps {
  nextButtonLabel: string;
  goBackButtonLabel: string;
  cancelButtonLabel: string;
  cancelButtonModalTitle: string;
  cancelButtonModalContent: string;
  shouldDisplayCancelAsButton?: boolean;
  isNextButtonDisabled: boolean;
  shouldDisplayGoBackButton?: boolean;
  continueButtonLabel: string;
  nextButtonAction: () => void;
  goBackButtonAction: () => void;
  cancelButtonAction: () => void;
}

export const FooterButtons: React.FC<IFooterButtonProps> = (
  props: IFooterButtonProps
) => {
  const productName = useAppSelector(
    (state) => state.insurance.offer.productName
  );
  const { isMobile } = useDeviceWidth();

  const renderGoBackButton = () => (
    props.shouldDisplayGoBackButton && (
      <Button
        onClick={props.goBackButtonAction}
        size="md"
        arrow="left"
        variant="secondary"
        className="go-back"
      >
        {props.goBackButtonLabel}
      </Button>
    )
  );

  const renderAbortPurchase = () => (
    <div className="justify-content-center d-flex abort-purchase">
      <AbortPurchase
        primaryActionText={props.continueButtonLabel}
        secondaryActionText={props.cancelButtonModalTitle}
        messageText={props.cancelButtonModalContent}
        headerText={props.cancelButtonModalTitle}
        toggleButtonText={props.cancelButtonLabel}
        handleSecondaryAction={() => {
          window.location.href = RoutingHelper.resolveFirstPageUrlPath(productName);
        }}
        trackingObject={tracker}
      />
    </div>
  );
  /* =================================================================
    We are not using the flex order to change the order of the buttons because its not supporting the accessibility standards for 
    keyboard tab order.
  */
  return (
    <>
      {isMobile ? (
        <>
          <Button
            onClick={props.nextButtonAction}
            tracking={false}
            className="next-radio-button critical-button-padding go-next"
            size="md"
            variant="primary"
            arrow="right"
            disabled={props.isNextButtonDisabled}
          >
            {props.nextButtonLabel}
          </Button>
          {renderGoBackButton()}
          {renderAbortPurchase()}
        </>
      ) : (
        <>
          <Flex >
            {renderGoBackButton()}
            <Button
              onClick={props.nextButtonAction}
              tracking={false}
              className="next-radio-button critical-button-padding go-next"
              size="md"
              variant="primary"
              arrow="right"
              disabled={props.isNextButtonDisabled}
            >
              {props.nextButtonLabel}
            </Button>
          </Flex>
          {renderAbortPurchase()}
        </>
      )}
    </>
  );
};
